<!--
 * @Description: file content
 * @Author: yangsibo
 * @Date: 2022-06-10 09:16:11
 * @LastEditors: yangsibo
 * @LastEditTime: 2022-06-10 17:19:56
 * @FilePath: \YunYin_admin\src\views\Cooperative\Disperse\index.vue
-->
<template>
 <router-view />
</template>

<script>
export default {
  name: "CooperativeDisperse",
  data() {
    return {};
  },
  components: {},
  mounted() {},
};
</script>

<style lang="scss" scoped>
</style>
